var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBulb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86252 10.8443C4.59763 10.2489 4.44995 9.5865 4.44995 8.88846C4.44995 6.29597 6.48706 4.19434 8.99995 4.19434C11.5129 4.19434 13.55 6.29597 13.55 8.88846C13.55 9.5865 13.4023 10.2489 13.1374 10.8443",
    stroke: "#141B34",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    className: "only-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.74426V2.44426",
    stroke: "#141B34",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "only-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.74426H15.3",
    stroke: "#141B34",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "only-stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 8.74426H2",
    stroke: "#141B34",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "only-stroke"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9493 3.79443L13.4543 4.28941",
    stroke: "#141B34",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "only-stroke"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54576 4.29002L4.05078 3.79504",
    stroke: "#141B34",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "only-stroke"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7618 13.8588C11.469 13.6301 11.7527 12.9827 11.8325 12.3316C11.8563 12.1371 11.6963 11.9757 11.5003 11.9757L6.53365 11.9758C6.33093 11.9758 6.16813 12.1479 6.19233 12.3492C6.27049 12.999 6.46775 13.4738 7.21727 13.8588M10.7618 13.8588C10.7618 13.8588 7.34065 13.8588 7.21727 13.8588M10.7618 13.8588C10.6767 15.2203 10.2835 15.7596 9.00462 15.7444C7.63668 15.7697 7.32198 15.1032 7.21727 13.8588",
    stroke: "#141B34",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "only-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/light-bulb.66bb56cb1567d794ebccc7411857f33e.svg";
export { ForwardRef as ReactComponent };